(function () {
    var ChangeLanguageController = /** @class */ (function () {
        function ChangeLanguageController($mdDialog, $translationService) {
            this.$mdDialog = $mdDialog;
            this.$translationService = $translationService;
            
            this.selectedLanguage = this.$translationService.getCurrentLanguageCode();
        }
        /**
         * Close dialog
         */
        ChangeLanguageController.prototype.closeDialog = function () {
            this.$mdDialog.cancel();
        };

        ChangeLanguageController.prototype.onOk = function () {            

            let currentLanguage = this.$translationService.getCurrentLanguageCode();

            if (currentLanguage === this.selectedLanguage) {
                this.$mdDialog.cancel(); 
            } else {
                this.$translationService.setCurrentLanguageCode(this.selectedLanguage);
                setTimeout(() => {
                    window.location.reload(true);
                }, 100);                
            }

            // console.log('----', this.selectedLanguage);
            // this.$mdDialog.cancel();
        };
        
        ChangeLanguageController.$inject = ['$mdDialog', '$translationService'];
        return ChangeLanguageController;
    }());
    angular.module('internal.changelanguage', []).controller('ChangeLanguageController', ChangeLanguageController);
})();
